/**
 * [Pure] Return subset of an array of objects where all properties match the passed object.
 * @param arr - Array of objects to filter.
 * @param obj - Object to match properties against.
 * @param isAny - Optional boolean for whether to use "all" or "any", defaults false / "all".
 */
export function filterByObj(arr: Array<any>, obj: any, isAny?: boolean): any {
    return arr.filter(e => {                                                // Filter array by matching properties to object.
        for (let i = 0, keys = Object.keys(obj); i < keys.length; i++) {    // Iterate over object keys.
            if (isAny && e[keys[i]] === obj[keys[i]]) return true;          // If matching "any" and any key matches, return true.
            if (!isAny && e[keys[i]] !== obj[keys[i]]) return false;        // If matching "all" and any key doesn't match, return false.
        }
        return !isAny;                                                      // If you make it through the loop, nothing exited (all = true, any = false).
    });
}
